import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Loading from 'components/Loading';
import { colors } from 'theme';
import { StockConditionneRepreneurByBuyerThenMaterial } from 'types';
import { formatTons } from 'utils/weight';

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: '20rem',
    '& *': {
      fontFamily: '"Open Sans", "Helvetica", "Arial", sans-serif',
    },
  },
  headerRow: {
    fontSize: '16px',
    textTransform: 'initial',
    borderBottom: 'none',
  },
  headerColumn: {
    '&:not(:first-of-type)': {
      borderLeft: `1px solid ${colors.greyLighten20}`,
    },

    lineHeight: '35px',
    margin: 0,
    padding: '0 16px',
  },
  dataRow: {
    height: 35,
    borderBottom: `1px solid ${colors.greyLighten20}`,
  },
  dataColumn: {
    '&:not(:first-of-type)': {
      borderLeft: `1px solid ${colors.greyLighten20}`,
    },

    lineHeight: '35px',
    padding: '0 16px',
    margin: 0,
  },
  noResultMessage: {
    fontFamily: '"Open Sans", "Helvetica", "Arial", sans-serif',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    paddingTop: '50px',
    border: '0px',
  },
}));

type ConditionneParRepreneurTableProps = {
  stockConditionneByBuyerThenMaterial: StockConditionneRepreneurByBuyerThenMaterial | null;
};

export const ConditionneParRepreneurTable: React.FC<ConditionneParRepreneurTableProps> = ({
  stockConditionneByBuyerThenMaterial,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  let lastBuyerName = '';

  if (null === stockConditionneByBuyerThenMaterial) return <Loading />;

  return (
    <div>
      {0 < stockConditionneByBuyerThenMaterial.length ? (
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell className={classes.headerColumn}>
                {t('stockConditionneParRepreneurPage.header.buyer')}
              </TableCell>
              <TableCell className={classes.headerColumn}>
                {t('stockConditionneParRepreneurPage.header.material')}
              </TableCell>
              <TableCell className={classes.headerColumn}>
                {t('stockConditionneParRepreneurPage.header.weight')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stockConditionneByBuyerThenMaterial.map(stockConditionneByBuyer => {
              if (0 < stockConditionneByBuyer.length) {
                return stockConditionneByBuyer.map(stockConditionneByMaterial => {
                  const buyerName =
                    lastBuyerName !== stockConditionneByMaterial.buyerName ? stockConditionneByMaterial.buyerName : '';
                  lastBuyerName = stockConditionneByMaterial.buyerName;
                  return (
                    <TableRow
                      className={classes.dataRow}
                      key={stockConditionneByMaterial.buyerName + stockConditionneByMaterial.materialName}
                    >
                      <TableCell className={classes.dataColumn}>{buyerName}</TableCell>
                      <TableCell className={classes.dataColumn}>{stockConditionneByMaterial.materialName}</TableCell>
                      <TableCell className={classes.dataColumn}>
                        {formatTons(stockConditionneByMaterial.tonnageKilo / 1000)}
                      </TableCell>
                    </TableRow>
                  );
                });
              }
              return null;
            })}
          </TableBody>
        </Table>
      ) : (
        <p className={classes.noResultMessage}>{t('stockConditionneParRepreneurPage.noResult')}</p>
      )}
    </div>
  );
};
